import * as React from 'react';
import './CardComponent.css';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Box } from "@mui/material";
import { IconButton } from '@mui/material';
import { Link } from "react-router-dom";
import HalfProgressComponent from "../HalfProgressComponent/HalfProgressComponent";
import { formatMonthYear } from "../../Utils/date";
import { slugify } from "../../Utils/url";
import { link } from 'fs';


interface CardProps {
    imgPath: string;
    data: {
        id: number;
        name: string;
        office: string;
        end_date?: Date | string;
        industry?: string;
        description: string;
        finished_stages: number;
        late_stages: number;
        over_year_late_stages: number;
        in_progress_stages: number;
        not_started_stages: number;
        current_stage: any;
        days_late: number;
    };
    onToggle?: () => void;
}

export default function CardComponent({ imgPath, data, onToggle }: CardProps) {
    return (

        <Card
            tabIndex={0}
            component={Link} to={`/project-about/${data.id}/${slugify(data.name)}`}

            sx={{
                width: '100%',
                height: 545,
                backgroundColor: "#EEF1F7",
                borderRadius: '30px',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                overflow: 'hidden',
                textDecoration: 'none'
            }}
        >
            <IconButton
                aria-expanded={false}
                aria-label={`תיאור מיזם ${data.name}`}
                sx={{
                    position: 'absolute',
                    top: 8,
                    left: 8,
                    backgroundColor: 'white',
                    boxShadow: 1,
                    '&:hover': {
                        backgroundColor: '#f0f0f0',
                    },
                    padding: 0.5,
                    width: 25,    
                    height: 25,
                    borderRadius: '50%',
                    zIndex: 1,
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    onToggle?.()
                }}
            >
                <img src="/images/i.svg" alt="" width={7} height={7} />
            </IconButton>
            <Link tabIndex={-1} style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer', }} to={`/project-about/${data.id}/${slugify(data.name)}`}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'white',
                        color: '#00457E',
                        fontSize: 14,
                        padding: '4px 8px',
                        borderRadius: '10px',
                        boxShadow: 1,
                        marginRight: '5px',
                        textTransform: 'none',
                        lineHeight: 1.75,
                        fontFamily: 'Heebo, sans-serif',
                        fontWeight: 'bold',
                        zIndex: 1,
                    }}
                >
                    <Box
                        component="img"
                        src={
                            data.industry === 'תחבורה'
                                ? '/images/bus.svg'
                                : data.industry === 'אתרים'
                                    ? '/images/settings.svg'
                                    : '/images/lightning.svg'
                        }
                        alt={``}
                        width={15}
                        height={15}
                        sx={{ ml: 1 }}
                    />
                    {data.industry}
                </Box>
                <CardMedia
                    sx={{ height: 250, width: '100%' }}
                    image={imgPath}
                />
                <CardContent sx={{ height: 100 }}>
                    <div className="cardContentBlock">
                        <Typography gutterBottom component="div" sx={{ fontSize: 'clamp(0.875, 2.2vw, 1.25rem)', textOverflow: 'ellipsis', color: '#00457E', fontWeight: 'bold' }}>
                            <h3 style={{ margin: 0, padding: 0 }}>{data.name}</h3>
                        </Typography>
                        <Typography variant="caption" sx={{ color: 'rgba(0, 69, 126, 1)' }}>
                            {data.office}
                        </Typography>
                    </div>
                </CardContent>
                <HalfProgressComponent
                    data={data}
                    currentStage={data.current_stage.stage_number}
                    radius={80}
                    stroke={15}
                />
                <Box display="flex" justifyContent="center" paddingBlockStart={4} paddingBlockEnd={4}>
                    <div className="endDateBox">
                        <Typography color={"white"} fontWeight={600}>
                            תאריך סיום משוער:{' '}
                            {data.end_date && data?.end_date !== 'TBD'
                                ? formatMonthYear(data.end_date)
                                : 'טרם נקבע'}
                        </Typography>
                    </div>
                </Box>
            </Link>
        </Card>
    );
}